/** Standalone entry: registers <scapescene-widget> and boots every host on
 * the page. */

// @font-face must live in the light DOM — the shadow-root stylesheet only
// sets --ss-font-sans, it doesn't emit the font binaries. This is a real
// (non-`?inline`, non-`?url`) import, so Vite's normal asset pipeline emits
// the font files as small fingerprinted files (well under its inline
// threshold) and a tiny fonts.css asset alongside the app bundle, linked
// automatically since this file reaches <script type="module"> in
// index.html. Safe/cheap even if a host page also links it — duplicate
// @font-face rules for the same files just win no-op races.
import "@starling-cloud/stylescape-starling-studio/font/fk_grotesk/fonts.css";

import { App } from "./app";
import { bootHost } from "./control/gui";

class WorkshopVideoElement extends HTMLElement {
  #app: App | null = null;

  connectedCallback(): void {
    this.#app = bootHost(this);
  }

  disconnectedCallback(): void {
    this.#app?.stop();
    this.#app = null;
  }
}

if (!customElements.get("scapescene-widget")) {
  customElements.define("scapescene-widget", WorkshopVideoElement);
}
